import Footer from '../components/Footer';
import MainRegistro from '../components/MainRegistro';
import ModalCodigo from '../components/ModalCodigo';
import NavBarLogin from '../components/NavBarLogin';

function Registro() {

    return (
        <>
            <NavBarLogin />
            <Footer isVisibleMobile={true} />
            <MainRegistro />
            <ModalCodigo isRegistro={1} />
        </>
    );
}


export default Registro;